module.exports = __webpack_public_path__ + "static/MineralSwimV2_Web_Existing-Pool-f18e19fccad4bdac25032e025d7d6b2e.jpg";